// Require

const { id, log, limit } = require("../std/index")


//
// Master Slice
//
// Base class implementing common responsibilities of a Slice
//

class Slice {
  constructor($host, config) {
    this.config = config;
    const featureHeight = $host.outerHeight();

    this.dom = {
      main: $host,
      surrogate: $host.clone().html("")
    };

    this.state = {
      offset: 0,
      progress: 0,
      height: featureHeight,
      scrollHeight: featureHeight * (this.config['scroll-factor'] || 1),
      scrollFactor: this.config['scroll-factor'] || 1
    };

    this.dom.main.css({ position: 'relative' });

    this.updateSelf();

    // DEBUG

    //this.dom.main.on('mousemove', ({ pageX }) => {
    //  const p = (pageX - this.dom.main.offset().left) / this.dom.main.outerWidth();
    //  this.setProgress(limit(0, 1, p));
    //});
  }

  type() {
    return this.config.slice;
  }

  selfTest(n, s = 2) {
    const t = 1000/s;
    const frame = () => {
      this.onProgress(n/2 + n/2 * Math.cos(Date.now() / t));
      requestAnimationFrame(frame);
    };
    frame();
  }

  updateSelf() {
    this.state.offset = this.dom.main.offset().top;   // non-scroll-locking mode
    //this.state.offset = this.dom.surrogate.offset().top;
    this.state.height = this.dom.main.outerHeight();
    this.state.scrollHeight = this.state.height * this.state.scrollFactor;
  }

  getCompensation() {
    return window.innerHeight * 2/3;
  }

  calcProgressFor(px) {
    return limit(0, this.state.scrollFactor, (px - this.state.offset + this.getCompensation()) / (this.state.height));
  }

  calcIllusionFor(px) {
    return this.state.height * limit(0, this.state.scrollFactor - 1, (px - this.state.offset) / this.state.height);
  }

  getDimensions() {
    return this.state;
  }

  getSurrogate() {
    this.state.found = true;
    return this.dom.surrogate;
  }

  setProgress(p, i = this.state['illusion-offset']) {
    //p = Math.max(0, p * 2 - 1);
    this.state.progress = p;
    this.state['illusion-offset'] = i;
    this.onProgress(this.state.progress);
  }

  onScroll(px) {
    this.updateSelf();
    const progress = this.calcProgressFor(px);
    const illusion = this.calcIllusionFor(px);
    this.setProgress(progress, illusion);
  }

  undiscovered() {
    return !this.state.found;
  }
}

module.exports = { Slice };
